module.exports = __webpack_public_path__ + "static/media/documentHand.675c4dc0.png";